import { useState, useEffect, useRef, useCallback } from 'react';

const reviews = [
  {
    stars: 5,
    date: 'vor 3 Tagen',
    text: 'Wir haben die Firma für eine Grundreinigung nach Renovierung gebucht. Fenster und Böden wurden richtig gründlich gemacht.',
    name: 'O. Nöllte',
    initials: 'ON',
    color: 'bg-emerald-600',
    service: 'Grundreinigung',
    local: 'Ratingen',
  },
  {
    stars: 5,
    date: 'vor 5 Tagen',
    text: 'Ilker und sein Team haben unsere Terrasse sauber gemacht und Unkraut entfernt. Ging schnell und Ergebnis passt.',
    name: 'Marc Setzer',
    initials: 'MS',
    color: 'bg-sky-600',
    service: 'Außenreinigung',
    local: 'Ratingen',
  },
  {
    stars: 5,
    date: 'vor einer Woche',
    text: 'Top Service! :)\nFairer Preis, gründlich und zuverlässig – gerne wieder!',
    name: 'Andre Derkac',
    initials: 'AD',
    color: 'bg-amber-600',
    service: 'Gebäudereinigung',
    local: 'Ratingen',
  },
  {
    stars: 5,
    date: 'vor einer Woche',
    text: 'Wir haben lange nach einer zuverlässigen Gebäudereinigung für unsere Büroräume gesucht und hier endlich jemanden gefunden. Man merkt einfach den Unterschied: Es wird nicht nur „sauber gemacht\", sondern wirklich mitgedacht und ordentlich gearbeitet. Alles wirkt konstant gepflegt, ohne dass man ständig hinterher sein muss. Genau die Art von Zusammenarbeit, die man sich im Alltag wünscht.\n\nNur zu empfehlen!',
    name: 'Leon Höök-Nilsson',
    initials: 'LH',
    color: 'bg-violet-600',
    service: 'Büroreinigung',
    local: 'Ratingen',
  },
  {
    stars: 5,
    date: 'vor einem Monat',
    text: 'Sehr gewissenhafte Reinigung. Top Service. Kann Ilker und sein Team nur weiterempfehlen!',
    name: 'Khai-Thanh Loc',
    initials: 'KL',
    color: 'bg-rose-600',
    service: 'Gebäudereinigung',
    local: 'Ratingen',
  },
  {
    stars: 5,
    date: 'vor einem Monat',
    text: 'Seit 2024 arbeiten wir regelmäßig mit IGM Facility zusammen und sind sehr zufrieden. Die Zusammenarbeit ist zuverlässig, professionell und unkompliziert. Nice Service stellt wirklich top Leute – wir freuen uns auf die weitere Zusammenarbeit. Klare Empfehlung!',
    name: 'LupenRhein GmbH (Cihan Y.)',
    initials: 'LR',
    color: 'bg-teal-600',
    service: 'Regelmäßige Reinigung',
    local: 'Ratingen',
  },
  {
    stars: 5,
    date: 'vor 2 Monaten',
    text: 'Wir sind sehr zufrieden mit dem Gebäudereinigungsservice. Das Team kommt bei uns jede Woche vorbei und sorgt zuverlässig dafür, dass alles sauber und ordentlich ist. Man merkt, dass gründlich gearbeitet wird – Böden, Oberflächen und Gemeinschaftsbereiche sind immer gepflegt. Die Mitarbeiter sind freundlich, pünktlich und arbeiten unauffällig im Hintergrund, sodass der Arbeitsalltag kaum gestört wird. Insgesamt ein sehr zuverlässiger Service, den wir gerne weiterempfehlen.',
    name: 'BRK Autohaus',
    initials: 'BA',
    color: 'bg-orange-600',
    service: 'Wöchentliche Reinigung',
    local: 'Ratingen',
  },
  {
    stars: 5,
    date: 'vor 3 Monaten',
    text: 'Herr Sahin und sein Team haben unseren Garten wieder auf Vordermann gebracht. War dringend nötig und hat sich gelohnt.',
    name: 'Caglar M.',
    initials: 'CM',
    color: 'bg-cyan-600',
    service: 'Gartenarbeiten',
    local: 'Düsseldorf',
  },
  {
    stars: 5,
    date: 'vor 7 Monaten',
    text: 'Haben IGM für die Reinigung beauftragt. Wird regelmäßig sauber gemacht, passt alles.',
    name: 'Kamps Bäckerei (D. Kurtlar)',
    initials: 'KB',
    color: 'bg-lime-600',
    service: 'Regelmäßige Reinigung',
    local: 'Mönchengladbach',
  },
  {
    stars: 5,
    date: 'vor 1 Monat',
    text: 'Haben die Firma für Renovierungsarbeiten beauftragt. Alles wie abgesprochen umgesetzt und keine bösen Überraschungen.',
    name: 'HAEP (Arda C.)',
    initials: 'HA',
    color: 'bg-pink-600',
    service: 'Renovierungsarbeiten',
    local: 'Hagen',
  },
];

const ratingBreakdown = [
  { stars: 5, pct: 94 },
  { stars: 4, pct: 4 },
  { stars: 3, pct: 1 },
  { stars: 2, pct: 1 },
  { stars: 1, pct: 0 },
];

function StarRow({ filled, empty = 0 }: { filled: number; empty?: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: filled }).map((_, i) => (
        <i key={`f${i}`} className="ri-star-fill text-[#FBBC04]" />
      ))}
      {Array.from({ length: empty }).map((_, i) => (
        <i key={`e${i}`} className="ri-star-line text-gray-300" />
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [containerWidth, setContainerWidth] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);

  const gap = 20;

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      setContainerWidth(entry.contentRect.width);
    });
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const isMobile = containerWidth > 0 && containerWidth < 640;
  const isTablet = containerWidth >= 640 && containerWidth < 1024;
  const visibleCount = isMobile ? 1 : isTablet ? 2 : 3;
  const cardWidth = isMobile
    ? containerWidth
    : isTablet
    ? Math.floor((containerWidth - gap) / 2)
    : 340;

  const next = useCallback(() => {
    setActiveIndex((i) => (i + 1) % reviews.length);
  }, []);

  const prev = () => setActiveIndex((i) => (i - 1 + reviews.length) % reviews.length);

  useEffect(() => {
    if (paused) return;
    const id = setInterval(next, 4000);
    return () => clearInterval(id);
  }, [paused, next]);

  const getOffset = () => {
    if (cardWidth === 0) return 0;
    const total = reviews.length;
    const maxOffset = total * (cardWidth + gap) - visibleCount * (cardWidth + gap);
    let offset = activeIndex * (cardWidth + gap);
    if (offset > maxOffset) offset = maxOffset;
    return offset;
  };

  return (
    <section className="py-16 sm:py-24 bg-[#F8F7F4] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 sm:mb-12">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-[2px] bg-[#C8A96E]" />
              <span className="text-[#C8A96E] text-sm font-semibold tracking-widest uppercase">Kundenstimmen</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
              Das sagen unsere Kunden
            </h2>
            <p className="text-gray-500 text-sm sm:text-base max-w-lg">
              15 verifizierte Bewertungen von echten Kunden aus der Region Rhein-Ruhr.
            </p>
          </div>

          {/* Google Rating Box */}
          <div className="w-full lg:w-auto lg:flex-shrink-0">
            <div className="bg-white rounded-2xl border border-gray-200 p-4 sm:p-5 lg:p-6 flex flex-row items-center gap-4 sm:gap-5">
              {/* Google Branding */}
              <div className="flex flex-col items-center text-center flex-shrink-0">
                <div className="flex items-center gap-1 mb-1">
                  <span className="font-bold text-[#4285F4] text-sm sm:text-base">G</span>
                  <span className="font-bold text-[#EA4335] text-sm sm:text-base">o</span>
                  <span className="font-bold text-[#FBBC05] text-sm sm:text-base">o</span>
                  <span className="font-bold text-[#4285F4] text-sm sm:text-base">g</span>
                  <span className="font-bold text-[#34A853] text-sm sm:text-base">l</span>
                  <span className="font-bold text-[#EA4335] text-sm sm:text-base">e</span>
                </div>
                <div className="text-4xl sm:text-5xl font-bold text-gray-900 leading-none">5,0</div>
                <StarRow filled={5} />
                <p className="text-xs text-gray-400 mt-1">15 Bewertungen</p>
              </div>

              {/* Divider */}
              <div className="w-px h-16 sm:h-20 bg-gray-200 flex-shrink-0" />

              {/* Rating Breakdown */}
              <div className="flex flex-col gap-1.5 flex-1 min-w-0">
                {ratingBreakdown.map((r) => (
                  <div key={r.stars} className="flex items-center gap-2">
                    <span className="text-xs text-gray-500 w-3 text-right flex-shrink-0">{r.stars}</span>
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-star-fill text-[#FBBC04] text-xs" />
                    </div>
                    <div className="flex-1 bg-gray-100 rounded-full h-1.5">
                      <div
                        className="bg-[#FBBC04] h-1.5 rounded-full transition-all duration-700"
                        style={{ width: `${r.pct}%` }}
                      />
                    </div>
                    <span className="text-xs text-gray-400 w-6 flex-shrink-0">{r.pct}%</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Carousel */}
        <div
          ref={containerRef}
          className="relative"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          {/* Cards track */}
          <div className="overflow-hidden">
            <div
              ref={trackRef}
              className="flex transition-transform duration-500 ease-in-out"
              style={{ gap: `${gap}px`, transform: `translateX(-${getOffset()}px)` }}
            >
              {reviews.map((review, idx) => (
                <div
                  key={review.name}
                  className={`flex-shrink-0 bg-white rounded-2xl border p-5 sm:p-6 flex flex-col justify-between transition-all duration-300 cursor-pointer ${
                    idx === activeIndex
                      ? 'border-[#0D2B4E]/30 ring-1 ring-[#0D2B4E]/10'
                      : 'border-gray-100 hover:border-gray-200'
                  }`}
                  style={{ width: cardWidth > 0 ? `${cardWidth}px` : '100%' }}
                  onClick={() => setActiveIndex(idx)}
                >
                  {/* Top row */}
                  <div>
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center gap-2.5">
                        <div className={`w-10 h-10 ${review.color} rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0`}>
                          {review.initials}
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm leading-tight">{review.name}</p>
                          <p className="text-xs text-gray-400">{review.local} · {review.date}</p>
                        </div>
                      </div>
                      {/* Google G icon */}
                      <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                        <span className="font-black text-xl leading-none" style={{ background: 'linear-gradient(135deg, #4285F4, #EA4335)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>G</span>
                      </div>
                    </div>

                    <StarRow filled={review.stars} />

                    <p className="text-gray-600 text-sm leading-relaxed mt-3 line-clamp-4">
                      {review.text}
                    </p>
                  </div>

                  {/* Bottom tag */}
                  <div className="mt-4 pt-4 border-t border-gray-50 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1.5 bg-gray-50 text-gray-500 text-xs px-3 py-1.5 rounded-full">
                      <i className="ri-tools-line text-[10px]" />
                      {review.service}
                    </span>
                    <div className="flex items-center gap-1">
                      <div className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-verified-badge-fill text-[#4285F4] text-xs" />
                      </div>
                      <span className="text-xs text-gray-400">Verifiziert</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Nav arrows — inside container on mobile, outside on desktop */}
          <button
            onClick={prev}
            className="absolute left-1 sm:-left-4 top-1/2 -translate-y-1/2 w-9 h-9 sm:w-10 sm:h-10 bg-white border border-gray-200 rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-left-s-line text-gray-700 text-xl" />
          </button>
          <button
            onClick={next}
            className="absolute right-1 sm:-right-4 top-1/2 -translate-y-1/2 w-9 h-9 sm:w-10 sm:h-10 bg-white border border-gray-200 rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-right-s-line text-gray-700 text-xl" />
          </button>
        </div>

        {/* Dot indicators */}
        <div className="flex justify-center gap-1.5 mt-6">
          {reviews.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setActiveIndex(idx)}
              className={`rounded-full transition-all duration-300 cursor-pointer ${
                idx === activeIndex ? 'w-6 h-2 bg-[#0D2B4E]' : 'w-2 h-2 bg-gray-300 hover:bg-gray-400'
              }`}
            />
          ))}
        </div>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mt-8 sm:mt-10">
          <a
            href="https://g.page/r/igmfacilityservice/review"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 text-gray-700 px-5 py-3 rounded-xl font-semibold text-sm hover:bg-gray-50 hover:border-gray-300 transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <span className="font-black text-base leading-none" style={{ background: 'linear-gradient(135deg, #4285F4, #34A853)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>G</span>
            Bewertung auf Google hinterlassen
          </a>
          <a
            href="https://maps.google.com/?q=IGM+Facility+Service+Ratingen"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#0D2B4E] font-semibold text-sm hover:underline cursor-pointer whitespace-nowrap"
          >
            <i className="ri-map-pin-line" />
            Alle Bewertungen auf Google Maps ansehen
          </a>
        </div>
      </div>
    </section>
  );
}
